
  (function() {
    /* Live cart-badge sync */
    var badge = document.querySelector('.js-app-bar__badge[data-cart-count]');
    if (badge) {
      function setCount(n) {
        n = parseInt(n, 10) || 0;
        badge.textContent = n > 99 ? '99+' : n;
        if (n > 0) badge.removeAttribute('hidden');
        else badge.setAttribute('hidden', '');
      }
      ['cart:refresh', 'cart:change', 'theme:cart:change', 'cart-quantity-update'].forEach(function(evt) {
        document.addEventListener(evt, function(e) {
          var d = e.detail || {};
          if (typeof d.itemCount !== 'undefined') return setCount(d.itemCount);
          if (typeof d.item_count !== 'undefined') return setCount(d.item_count);
          fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ setCount(c.item_count); }).catch(function(){});
        });
      });
    }

    /* HAMBURGER_DRAWER_WIRE v2 2026-07-06, open the theme-owned drawer
       (snippets/mobile-nav-drawer.liquid). The previous wire targeted
       Prestige's <header-sidebar>, which theme-refresh.css permanently
       hides (2026-05-03 bleed fix), the button did nothing. */
    var menuBtn = document.getElementById('js-app-bar-menu');
    if (menuBtn) {
      menuBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (window.jsqNavDrawer && typeof window.jsqNavDrawer.open === 'function') {
          window.jsqNavDrawer.open();
        } else {
          /* Last-resort fallback: open the curated department hub. */
          window.location.href = '/pages/shop';
        }
      });
    }
  })();
